import React from 'react'
import styled from 'styled-components';
import { colors } from '../styles/vars'
import creditIcon from '../static/images/icons/yit.png'

const StyledFooter = styled.footer`
background-color:${colors.black};
`;
const FooterContent = styled.div`
padding:10px 0 6px;
text-align:center;
`

const Footer = (props) => {
    return (
        <StyledFooter>
            <FooterContent>
                <a
                    href="https://www.yit.co.il/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={creditIcon} alt="yit" />
                </a>
            </FooterContent>
        </StyledFooter>
    )
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.jsx